var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMagicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.4747 3.67977C15.1701 5.76893 16.8051 7.4191 18.8943 8.11754C16.8197 8.81354 15.1723 10.4483 14.4744 12.5363C13.7783 10.4614 12.1432 8.81384 10.0548 8.1161C12.1303 7.41713 13.7766 5.76852 14.4747 3.67977Z",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.2799 13.9852C8.80416 14.5661 7.63154 15.7387 7.0506 17.2145C6.46966 15.7387 5.29704 14.5661 3.82127 13.9852C5.29734 13.4038 6.46976 12.2292 7.0506 10.7428C7.63144 12.2292 8.80386 13.4038 10.2799 13.9852ZM7.0506 9.52637C6.94544 9.52637 6.86131 9.58946 6.84028 9.69463L7.30058 9.87321C7.29349 9.8437 7.28665 9.81409 7.28005 9.78437C7.27991 9.78375 7.27977 9.78312 7.27963 9.7825C7.27316 9.7533 7.26692 9.72401 7.26092 9.69463C7.23989 9.58946 7.15576 9.52637 7.0506 9.52637Z",
    stroke: "#555555"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M4.33456 8.15786C3.75355 6.65548 2.55071 5.44902 1.05872 4.87734C2.57373 4.29815 3.75768 3.10066 4.33454 1.58664C4.90292 3.10349 6.10016 4.29912 7.61543 4.87734C6.12311 5.44805 4.90708 6.65261 4.33456 8.15786Z",
    stroke: "#555555"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagicIcon);
export default __webpack_public_path__ + "static/media/magic_icon.32c66aac1c4f503f4ef093ceaea0d2a3.svg";
export { ForwardRef as ReactComponent };